import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/config";
import "./blogPage.css";

export default function BlogPage() {

  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);
  const [visibleCount, setVisibleCount] = useState(6); // 🔥 load 6 first

  // ================= LOAD BLOGS =================
  useEffect(() => {

    // 🔥 CACHE FIRST
    const cached = localStorage.getItem("blogsData");
    if (cached) {
      try {
        setBlogs(JSON.parse(cached));
      } catch {}
    }

    // 🔥 FIRESTORE
    const ref = collection(db, "blogs");

    const unsub = onSnapshot(ref, (snap) => {
      const data = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setBlogs(data);
      localStorage.setItem("blogsData", JSON.stringify(data));
    });

    return () => unsub();
  }, []);

  const visibleBlogs = blogs.slice(0, visibleCount);

  return (
    <section className="blog-page">

      {/* 🔙 BACK */}
      <div className="blog-topbar">
        <button
          className="back-btn"
          onClick={() => navigate(-1)}
        >
          ← Back
        </button>
      </div>

      {/* HEADER */}
      <div className="blog-header">
        <h1>Academic Insights</h1>
        <p>Thoughts, research, and reflections on literature and education</p>
      </div>

      {/* GRID */}
      <div className="blog-grid">
        {visibleBlogs.map((blog) => (
          <div key={blog.id} className="blog-card">

            <img src={blog.img} alt={blog.title} />

            <div className="blog-content">
              <span className="date">{blog.date}</span>

              <h3>{blog.title}</h3>

              <p>{blog.desc}</p>

              <button
                className="read-more"
                onClick={() => navigate(`/blog/${blog.id}`)}
              >
                Read More →
              </button>
            </div>

          </div>
        ))}
      </div>

      {/* 🔥 LOAD MORE */}
      {visibleCount < blogs.length && (
        <div className="blog-load-more">
          <button
            onClick={() => setVisibleCount(prev => prev + 6)}
          >
            Load More ↓
          </button>
        </div>
      )}

    </section>
  );
}